export const onlineOptions = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];